import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';

export const DashboardUserFavorite = (props) => {
    const favoriteData = props.userFavoriteList || [];

    const history = useHistory();

    const handleRowClick = (favorite) => {      
        if (!favorite) {
            console.error("Favorite data is missing for row click.");
            return;
        }
        history.push(
            `/product/${favorite.itemNumberShort}`
        );
    };

    return (
        <>
            {props.storeSettings.settingsList.UseDashboardUserFavorite === "1" &&(
                <div className="order-panel">
                    <div className="title-flex-container">
                        <div className="title-flex-container" style={{ paddingBottom: '1rem' }}>
                            <div>
                                <FavoriteBorderRoundedIcon sx={{ fontSize: 40, color: 'black', paddingTop: '1rem' }} />
                            </div>

                            <div className="title-label">  {props.dashboardLabels.MyFavorites}
                            </div>
                        </div>
                        <div
                            className={
                                "expand-wrapper"
                            }
                        >
                            <Link
                                className="link-style"
                                to={{
                                    pathname: "/UserFavorite",
                                    query: { statuses: [], dateRange: 729 },
                                }}
                            >
                                <button className="expand-button">
                                    <text className="expand-button-text">
                                        {props.dashboardLabels.ViewAll}
                                    </text>
                                </button>
                            </Link>
                        </div>
                    </div>

                    <div className="data-flex-container">
                        {favoriteData?.length > 0 ? (
                            <table className="table-style">
                                <th className="th-left">{props.dashboardLabels.Product}</th>
                                <th className="th-middle-left"></th>
                                <th className="th-middle-left">{props.dashboardLabels.Description_Label}</th>
                                {favoriteData.slice(0, 10).map((favorite) => {
                                    return (
                                        <tr className="row-wrapper" key={favorite.sku}>
                                            <td
                                                onClick={() => handleRowClick(favorite)}
                                                className="td-left-link"
                                            >
                                               {favorite.sku}
                                            </td>
                                            <td className="td-po"></td>
                                            <td className="td-po">{favorite.description}</td>
                                        </tr>
                                    );
                                })}
                            </table>
                        ) : (
                            <div>{props.dashboardLabels.NoDataUserFavorite}</div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

DashboardUserFavorite.propTypes = {
    favoriteData: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        selectedCustomer: state.user.selectedCustomer,
    };
}

export default connect(mapStateToProps, null)(DashboardUserFavorite);
